import PropTypes from 'prop-types'
import styled from 'astroturf/react'
import { useDeviceType } from '@calendly/ui/hooks/use-device-type'
import { getTimezoneName } from '@calendly/timezone-tools'
import { TimezoneIcon } from '@calendly/ui/components/icons'
import _PreviewContainer from "timezone_preview-PreviewContainer.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/enter_details/collapsible_spot_times/timezone_preview.js?styleId=PreviewContainer";



const PreviewContainer = /*#__PURE__*/styled('div', null, {
  displayName: "PreviewContainer",
  styles: _PreviewContainer,
  attrs: props => ({
    ...props,
    isPhone: useDeviceType('isPhone')
  })
})

const ToggleLabel = ({ timezone, emptyTimezoneLabel = '' }) => (
  <>
    <TimezoneIcon spacingRight={12} />
    <span>
      {timezone ? getTimezoneName(timezone) : emptyTimezoneLabel}
    </span>
  </>
)

const Preview = ({ timezone, emptyTimezoneLabel, ...props }) => (
  <PreviewContainer {...props}>
    <ToggleLabel timezone={timezone} emptyTimezoneLabel={emptyTimezoneLabel} />
  </PreviewContainer>
)

Preview.propTypes = {
  timezone: PropTypes.string,
  emptyTimezoneLabel: PropTypes.string
}

export default Preview
